<div class="ui-g-12">
    <div id="map" leaflet [leafletOptions]="options" [leafletBaseLayers]="baseLayers" [leafletLayersControlOptions]="layersControlOptions" 
         (leafletMapReady)="onMapReady($event)"></div>
</div>
